import React from 'react';
interface SlideHeadlineProps {
  lead: string;
  follow: string;
  size?: 'large' | 'medium';
  className?: string;
}

/** Two-line confident headline: statement, then the turn. */
export function SlideHeadline({
  lead,
  follow,
  size = 'large',
  className = ''
}: SlideHeadlineProps) {
  return <h2 className={['font-heading leading-[0.95] tracking-[-0.035em] text-background', size === 'large' ? 'text-[46px] sm:text-[64px] xl:text-[76px]' : 'text-[40px] sm:text-[54px] xl:text-[62px]', className].join(' ')} data-id="element-132" data-mp="1y3wgkwz1ecv4">
      {lead}
      <span className="block text-[rgba(1,51,43,0.42)]" data-id="element-133" data-mp="2c4z2n9q17n61">{follow}</span>
    </h2>;
}